import { render, staticRenderFns } from "./publicity_file_upload.vue?vue&type=template&id=3609505c&scoped=true&"
import script from "./publicity_file_upload.vue?vue&type=script&lang=js&"
export * from "./publicity_file_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3609505c",
  null
  
)

export default component.exports